import OralMedPage from '../pages/OralMed';
import { ROUTES } from './routes.config';

export const OralMedRoutes = {
  path: ROUTES.ORALMED,
  element: <OralMedPage />,
};
  
